import React, { Component } from 'react';
import { __ } from '../Translator';

class FloatingCustomProductHash extends Component {
  render() {
    return this.props.hash ? (
      <div className="row">
        <div className="customizationHash m--floating col-sm-2">
          <p className="customizationHash__text">
            {__('Your unique customization code:')}
            <span className="customizationHash__code">
              {this.props.hash}
            </span>
          </p>
        </div>
      </div>
    ) : null;
  }
}
export default FloatingCustomProductHash;



// WEBPACK FOOTER //
// ./src/components/FloatingCustomProductHash.js